import { useContext } from 'react';
import { createNamedContext } from "./internal";
var ParamsContext = createNamedContext('Params', {});

var useParams = function useParams() {
  var params = useContext(ParamsContext);
  return params;
};

export { ParamsContext, useParams };